export enum SpinDirection {
  Down,
  Up,
}

export enum HudBoard {
  Hand,
  Mcip,
  Win,
  Lose,
  Blank,
  Pot
}

export enum CardType {
  CLUB_1 = "club_1",
  CLUB_2 = "club_2",
  CLUB_3 = "club_3",
  CLUB_4 = "club_4",
  CLUB_5 = "club_5",
  CLUB_6 = "club_6",
  CLUB_7 = "club_7",
  CLUB_8 = "club_8",
  CLUB_9 = "club_9",
  CLUB_10 = "club_10",
  CLUB_11 = "club_11",
  CLUB_12 = "club_12",
  CLUB_13 = "club_13",
  CLUB_14 = "club_14",
  DIAMOND_1 = "diamond_1",
  DIAMOND_2 = "diamond_2",
  DIAMOND_3 = "diamond_3",
  DIAMOND_4 = "diamond_4",
  DIAMOND_5 = "diamond_5",
  DIAMOND_6 = "diamond_6",
  DIAMOND_7 = "diamond_7",
  DIAMOND_8 = "diamond_8",
  DIAMOND_9 = "diamond_9",
  DIAMOND_10 = "diamond_10",
  DIAMOND_11 = "diamond_11",
  DIAMOND_12 = "diamond_12",
  DIAMOND_13 = "diamond_13",
  DIAMOND_14 = "diamond_14",
  HEART_1 = "heart_1",
  HEART_2 = "heart_2",
  HEART_3 = "heart_3",
  HEART_4 = "heart_4",
  HEART_5 = "heart_5",
  HEART_6 = "heart_6",
  HEART_7 = "heart_7",
  HEART_8 = "heart_8",
  HEART_9 = "heart_9",
  HEART_10 = "heart_10",
  HEART_11 = "heart_11",
  HEART_12 = "heart_12",
  HEART_13 = "heart_13",
  HEART_14 = "heart_14",
  SPADE_1 = "spade_1",
  SPADE_2 = "spade_2",
  SPADE_3 = "spade_3",
  SPADE_4 = "spade_4",
  SPADE_5 = "spade_5",
  SPADE_6 = "spade_6",
  SPADE_7 = "spade_7",
  SPADE_8 = "spade_8",
  SPADE_9 = "spade_9",
  SPADE_10 = "spade_10",
  SPADE_11 = "spade_11",
  SPADE_12 = "spade_12",
  SPADE_13 = "spade_13",
  SPADE_14 = "spade_14",
  CARD_BACK = "card_back",
}

export enum SeatPosition {
  SB,
  BB,
  UTG,
  UTG1,
  CO,
  BTN
}

export type StageSize = {
  width: number;
  height: number;
};

export enum PokerHand {
  Flush = "Flush",
  StraightFlush = "Straight Flush",
  RoyalFlush = "Royal Flush",
}

export enum Street {
  PreFlop = "PRE FLOP",
  Flop = "FLOP",
  Turn = "TURN",
  River = "RIVER",
}

export enum PokerAction {
  Check = "CHECK",
  Bet = "BET",
  Fold = "FOLD",
  Call = "CALL",
  Raise = "RAISE",
  AllIn = "ALLIN",
  Ante = "ANTE",
}

export type ImageRecord = Record<string, ArrayBuffer>;

export enum GameState {
  NewGame = "NEW_GAME",
  UnfinishedGame = "UNFINISHED_GAME",
}

export type Equity = {
  [key in Street & "SHOWDOWN"]: number;
};

export type PlayerDetails = {
  userName: string;
  winnings: string;
  winType: string;
  holeCards: CardType[];
  playerPosition: string;
  playerId: string;
  balance: string;
  openingBalance: string;
  equity: Equity;
};

export type StreetDetails = {
  position: string;
  playerId: string;
  action: string;
  amount: string;
  time: string;
  isAllIn?: boolean;
};

export type RoundDetails = {
  [key in Street & PokerAction.Ante]: StreetDetails[];
};

export type BountyDetails = {
  playerId: string;
  hunting: number;
  huntingMe: number;
  openingBounty: string;
  bounty: string;
  openingBank: string;
  bank: string;
};

export type Bountyleaderboard = {
  playerId: string;
  bounty: string;
};

export type BankLeader = {
  playerId: string;
  openingBank: string;
};

export type TournamentDetails = {
  bankLeader: BankLeader;
  bountyLeaderboard: Bountyleaderboard[];
  bountyPlayerDetails: BountyDetails[];
};

export type HandDetails = {
  _id: string;
  handId: string;
  tableId: number;
  playerCount: number;
  smallBlind: number;
  bigBlind: number;
  totalPot: number;
  noOfHoleCards: number;
  communityCards: CardType[];
  playerDetails: PlayerDetails[];
  roundDetails: RoundDetails;
  ante: number;
  didShowdown: boolean;
  tournamentId: string;
  tournamentDetails: TournamentDetails;
  handNo: number;
};

export type FlushDetails = {
  handId: string;
  handNo: number;
  flushType: PokerHand | string;
};

export type Summary = {
  startingBounty: string;
  startingBalance: string;
  handsPlayed: number;
  firstFlush: FlushDetails | null;
  secondFlush: FlushDetails | null;
  bountiesWonCount: number;
  totalJackpotWon: string;
  totalBountyWon: string;
  totalWinnings: string;
  startingBigBlind: number;
  startingSmallBlind: number;
};

export type JackpotDetails = {
  flushAmount: string;
  straightFlushAmount: string;
  royalFlushAmount: string;
};

export type BuyIn = {
  configId: string;
  buyIn: number;
};

export type GameData = {
  state: string;
  createdAt: string;
  buyIns: BuyIn[];
};

export interface Payout {
  tournamentId: string;
  buyIn: string;
  playersCount: number;
  bountyRtp: string;
  distributionMatrix: [string, number][];
  jackpotRtp: string;
  jackpotDistributionMatrix: string[];
}

export enum GameType {
  BTY = "BTY",
}

export type GameTypes = keyof typeof GameType;

export type MaintenanceGame = {
  enabled: boolean;
  announcementEnabled: boolean;
  maintenanceAnnouncement: string;
  maintenanceMessage: string;
};

export interface IMaintenanceFields {
  allowedUsers: string[];
  games: Record<GameTypes, MaintenanceGame>;
}

export interface FeatureFlagsState {
  maintenance: {
    enableMaintenance?: boolean;
    enableRegistration?: boolean;
    maintenanceMessage?: string;
    allowedUsers?: string[];
  };
  announcement: {
    showAnnouncement?: boolean;
    announcementMessage?: string;
    announcementId?: string;
  };
}


export type LayoutContext = {
  isReady: boolean;
  onPlay: (rejoin: boolean) => void;
  onConfirm: (buyIn: BuyIn) => void;
  onLobby: () => void;
};

export const MinHeight = 640;

export const MediaQuery = {
  ACR: `height < ${MinHeight}px`,
  Desktop: `height > ${MinHeight - 1}px`
};

export type Stats = {
  minStartingBounty: number,
  maxStartingBounty: number
  startingSmallBlind: number,
  startingBigBlind: number
};
